/**
 * Conteúdo do estilo CURIOSIDADES.
 *
 * Dois cuidados valem para tudo aqui:
 *
 * 1. o **texto é original**, escrito para este produto — a curiosidade é um fato
 *    do mundo (fato não tem dono), mas a frase que conta o fato é nossa. Nada é
 *    copiado de livro, site ou revista;
 * 2. o fato tem de ser **verdadeiro e conferível**. Nada de "dizem que" nem de
 *    número redondo inventado: é material escolar e de mesa de jantar, e quem
 *    escreve à mão no caderno vai repetir isso para alguém.
 *
 * Cada entrada serve dois quadros do dia: `CURIOSIDADE_DO_DIA` (o tema e o fato)
 * e `EXPERIMENTE_HOJE` (uma coisa pequena para observar ou testar no dia). O dia
 * do miolo escolhe a entrada por `índice % CURIOSIDADES.length`, então o mesmo
 * período reimpresso traz exatamente as mesmas curiosidades.
 */
export const CURIOSIDADES = [
    {
        tema: 'Abelhas',
        fato: 'A abelha que encontra comida volta para a colmeia e conta onde ela está dançando.',
        detalhe: 'O giro e o tempo da dança indicam a direção e a distância do alimento.',
        experimente: 'Observe uma flor cheia de abelhas e conte quantas chegam e saem em um minuto.',
    },
    {
        tema: 'Mel',
        fato: 'Um pote de mel bem fechado pode durar séculos sem estragar.',
        detalhe: 'Ele tem pouquíssima água e é ácido, um ambiente em que quase nenhum micróbio vive.',
        experimente: 'Coloque uma gota de mel na água: ela afunda e demora a se misturar.',
    },
    {
        tema: 'Polvo',
        fato: 'O polvo tem três corações e sangue azul.',
        detalhe: 'Dois corações bombeiam sangue para as brânquias e o terceiro, para o resto do corpo.',
        experimente: 'Procure a expressão “sangue azul” e veja por que o cobre, e não o ferro, dá cor ao sangue dele.',
    },
    {
        tema: 'Banana',
        fato: 'A banana é uma baga; o morango, do ponto de vista do botânico, não é.',
        detalhe: 'Vira baga o fruto que nasce de uma flor com um só ovário e guarda as sementes dentro.',
        experimente: 'Na feira, compare banana, tomate e morango e tente achar as sementes de cada um.',
    },
    {
        tema: 'Tomate',
        fato: 'O tomate é fruta na botânica e verdura na cozinha.',
        detalhe: 'A confusão é antiga: em 1893, uma corte dos Estados Unidos o tratou como verdura por causa de imposto.',
        experimente: 'Faça uma salada e liste quais itens dela são frutas de verdade.',
    },
    {
        tema: 'Luz do Sol',
        fato: 'A luz que chega agora ao seu olho saiu do Sol há cerca de 8 minutos.',
        detalhe: 'A luz anda a 300 mil km por segundo, e o Sol está a 150 milhões de km daqui.',
        experimente: 'Ao meio-dia, imagine que a luz que você vê é a de oito minutos atrás.',
    },
    {
        tema: 'Lua',
        fato: 'A Lua se afasta da Terra cerca de 3,8 cm por ano.',
        detalhe: 'É possível medir isso porque os astronautas deixaram espelhos na superfície lunar.',
        experimente: 'Registre a fase da Lua hoje e compare com a da mesma data no mês que vem.',
    },
    {
        tema: 'Coração',
        fato: 'Seu coração bate perto de 100 mil vezes por dia.',
        detalhe: 'São cerca de 5 litros de sangue empurrados por minuto, mesmo quando você dorme.',
        experimente: 'Conte os batimentos em 15 segundos e multiplique por quatro.',
    },
    {
        tema: 'Cérebro',
        fato: 'O cérebro é só 2% do peso do corpo e consome cerca de 20% da energia dele.',
        detalhe: 'Pensar, decidir e lembrar são trabalhos caros: é o órgão que mais gasta glicose.',
        experimente: 'Depois de um estudo difícil, note o cansaço: é gasto de verdade.',
    },
    {
        tema: 'Impressões digitais',
        fato: 'As impressões digitais se formam antes do nascimento e não mudam de desenho.',
        detalhe: 'Elas se marcam no feto por volta da 17ª semana e só acompanham o crescimento da mão.',
        experimente: 'Carimbe o dedo em um papel com lápis raspado e procure as linhas que formam espirais.',
    },
    {
        tema: 'Espirro',
        fato: 'Um espirro sai a mais de 100 km por hora e espalha gotículas a metros de distância.',
        detalhe: 'É por isso que cobrir o nariz e o braço com o antebraço importa tanto.',
        experimente: 'Espirre em direção a um espelho limpo e veja as marcas que ficam.',
    },
    {
        tema: 'Formigas',
        fato: 'Uma formiga consegue carregar várias vezes o próprio peso.',
        detalhe: 'A força é parecida com a nossa em músculo; o que muda é a proporção do corpo.',
        experimente: 'Siga uma trilha de formigas por um minuto e veja o que elas carregam.',
    },
    {
        tema: 'Tubarões',
        fato: 'Os tubarões existem há mais tempo que as árvores.',
        detalhe: 'Eles nadam nos oceanos há cerca de 400 milhões de anos; as primeiras árvores vieram bem depois.',
        experimente: 'Desenhe uma linha do tempo com tubarão, árvore e ser humano na ordem certa.',
    },
    {
        tema: 'Girafas',
        fato: 'A girafa tem o mesmo número de vértebras no pescoço que você: sete.',
        detalhe: 'As delas são apenas muito maiores — cada uma pode passar de 25 cm.',
        experimente: 'Conte as vértebras do seu próprio pescoço pelo tato, da nuca até o ombro.',
    },
    {
        tema: 'Beija-flor',
        fato: 'O beija-flor bate as asas até 80 vezes por segundo e consegue ficar parado no ar.',
        detalhe: 'O coração dele pode passar de 1.000 batimentos por minuto quando voa.',
        experimente: 'Cronometre 10 segundos ao lado de um bebedouro de beija-flor e conte as visitas.',
    },
    {
        tema: 'Camelos',
        fato: 'A corcova do camelo guarda gordura, não água.',
        detalhe: 'Essa reserva alimenta o animal em travessias longas, e a água vem do que ele bebe antes.',
        experimente: 'Veja quantos dias você passa sem lanche entre as refeições e anote a energia.',
    },
    {
        tema: 'Baleias',
        fato: 'O canto de algumas baleias atravessa oceanos e pode durar horas.',
        detalhe: 'O som viaja muito melhor na água do que no ar, e por isso alcança centenas de quilômetros.',
        experimente: 'Debaixo da água da piscina, bata dois objetos e compare o som com o de fora.',
    },
    {
        tema: 'Estrela-do-mar',
        fato: 'A estrela-do-mar não tem cérebro e mesmo assim caça e se orienta.',
        detalhe: 'A rede de nervos dela se espalha pelo corpo e pelos braços, sem centro de comando.',
        experimente: 'Procure outra criatura sem cérebro e anote como ela resolve o dia.',
    },
    {
        tema: 'Cheiro de chuva',
        fato: 'O cheiro de terra molhada tem nome: geosmina.',
        detalhe: 'É uma substância feita por bactérias do solo, que o vento espalha antes da chuva chegar.',
        experimente: 'No próximo dia de chuva, cheire o ar antes e depois de molhar e compare.',
    },
    {
        tema: 'Arco-íris',
        fato: 'O arco-íris sempre aparece no lado oposto ao Sol, com o vermelho por fora.',
        detalhe: 'A luz entra na gota, se separa nas cores e volta: o ângulo é de cerca de 42 graus.',
        experimente: 'Com uma mangueira de jardim, faça um arco-íris de manhã e veja a ordem das cores.',
    },
    {
        tema: 'Nuvens',
        fato: 'Uma nuvem comum pode pesar centenas de toneladas.',
        detalhe: 'As gotículas são minúsculas e sobem com o ar quente; juntas, somam muito peso.',
        experimente: 'Hoje olhe para o céu e classifique as nuvens em altas, médias e baixas.',
    },
    {
        tema: 'Raios',
        fato: 'O canal de um raio esquenta mais que a superfície do Sol.',
        detalhe: 'A temperatura passa de 30.000 °C por uma fração de segundo, e é isso que faz o trovão.',
        experimente: 'Na próxima tempestade, conte os segundos entre o clarão e o trovão e divida por três.',
    },
    {
        tema: 'Neve e som',
        fato: 'A neve recém-caída deixa o mundo mais silencioso.',
        detalhe: 'Os flocos têm muitos vazios internos, que absorvem o som como um forro acústico.',
        experimente: 'Pesquise um vídeo de rua coberta de neve e compare o ruído com o do mesmo local seco.',
    },
    {
        tema: 'Oceano',
        fato: 'Conhecemos melhor a superfície de Marte do que o fundo dos nossos oceanos.',
        detalhe: 'A pressão e a escuridão tornam o mapeamento do fundo muito mais difícil que o do espaço.',
        experimente: 'Veja num mapa quais pontos do fundo do mar já foram medidos com detalhe.',
    },
    {
        tema: 'Árvores',
        fato: 'Árvores trocam sinais pelo subsolo, ligadas por fungos nas raízes.',
        detalhe: 'A rede leva água, minerais e avisos entre árvores próximas — até entre espécies diferentes.',
        experimente: 'Observe um tronco com cogumelos na base e anote o que eles indicam sobre o solo.',
    },
    {
        tema: 'Bambu',
        fato: 'Existem bambus que crescem quase um metro por dia.',
        detalhe: 'O caule já vem pronto dentro do broto: ele se estica, em vez de construir do zero.',
        experimente: 'Meça uma planta da casa hoje e de novo na mesma hora da semana que vem.',
    },
    {
        tema: 'Café',
        fato: 'O cheiro do café é quase todo dos óleos que se formam ao torrar o grão.',
        detalhe: 'São mais de 800 compostos aromáticos, e por isso nenhuma essência imita bem o original.',
        experimente: 'Cheire o pó antes e depois de passar: são aromas diferentes.',
    },
    {
        tema: 'Chocolate',
        fato: 'O chocolate era bebida antes de virar barra.',
        detalhe: 'Povos da América Central tomavam cacau batido com especiarias, amargo e com espuma.',
        experimente: 'Prove um cacau 100% e um chocolate ao leite e compare o amargor.',
    },
    {
        tema: 'Papel',
        fato: 'O papel chegou ao Brasil trazido pelos portugueses, feito de trapos de roupa.',
        detalhe: 'A fibra de madeira só passou a ser usada em larga escala no século XIX.',
        experimente: 'Rasgue um pedaço de papel e observe as fibras na borda do corte.',
    },
    {
        tema: 'Lápis',
        fato: 'O lápis não tem chumbo: o que escreve é grafite, uma forma de carbono.',
        detalhe: 'O nome ficou da época em que se usava chumbo de verdade para riscar.',
        experimente: 'Teste um lápis 2B e um HB no mesmo papel e compare o escuro do traço.',
    },
    {
        tema: 'Tesoura',
        fato: 'A tesoura é uma alavanca dupla: cada cabo multiplica a força da mão.',
        detalhe: 'Cabos longos e lâminas curtas cortam mais fácil; por isso a de poda é grande.',
        experimente: 'Corte um papel com a tesoura perto da ponta e depois perto do parafuso e compare.',
    },
    {
        tema: 'Relógios',
        fato: 'Um relógio de quartzo acerta mais que qualquer relógio mecânico comum.',
        detalhe: 'A vibração de um cristal de quartzo é muito regular: 32.768 vezes por segundo.',
        experimente: 'Compare a hora do seu celular com a de um relógio de parede ao longo do dia.',
    },
    {
        tema: 'Wi-Fi',
        fato: 'O Wi-Fi é rádio, só que numa frequência que a maioria dos aparelhos não usa para outra coisa.',
        detalhe: 'Ele trabalha em 2,4 ou 5 GHz, por isso a parede e o micro-ondas atrapalham.',
        experimente: 'Meça a velocidade da internet longe e perto do roteador e anote a diferença.',
    },
    {
        tema: 'GPS',
        fato: 'O GPS só funciona porque os relógios dos satélites atrasam em relação aos nossos.',
        detalhe: 'A diferença vem da gravidade e da velocidade, e é corrigida pelo próprio sistema.',
        experimente: 'Veja quantos satélites o seu celular enxerga agora num aplicativo de GPS.',
    },
    {
        tema: 'Espelho',
        fato: 'O espelho não inverte direita e esquerda: inverte a frente e o fundo.',
        detalhe: 'É por isso que a letra na camiseta aparece trocada, e não de cabeça para baixo.',
        experimente: 'Escreva seu nome num papel, coloque atrás de um copo de água e leia.',
    },
    {
        tema: 'Memória',
        fato: 'Lembrar é reconstruir, e não reencontrar uma gravação.',
        detalhe: 'Cada vez que você conta uma história, o cérebro monta a cena de novo — e ela muda um pouco.',
        experimente: 'Conta para alguém uma lembrança antiga e note quais detalhes você já não tem certeza.',
    },
    {
        tema: 'Sono',
        fato: 'Durante o sono o cérebro limpa resíduos que se acumulam acordado.',
        detalhe: 'É parte do motivo de uma noite mal dormida deixar o raciocínio lento.',
        experimente: 'Anote a hora de dormir e como você acorda amanhã, por três dias.',
    },
    {
        tema: 'Gelo',
        fato: 'O gelo flutua porque, ao congelar, a água fica menos densa.',
        detalhe: 'As moléculas se organizam em uma rede aberta, com mais espaço vazio dentro.',
        experimente: 'Encha um copo até a borda e veja o gelo derreter sem transbordar.',
    },
    {
        tema: 'Sal',
        fato: 'Sal derrete gelo, mas esfria a água antes de aquecê-la de novo.',
        detalhe: 'Ele abaixa o ponto de congelamento; por isso se usa sal nas estradas no inverno.',
        experimente: 'Coloque gelo em dois copos, salgue um deles e compare quanto tempo cada um demora.',
    },
    {
        tema: 'Pipoca',
        fato: 'A pipoca estoura porque a água dentro do grão vira vapor e empurra o amido.',
        detalhe: 'O grão precisa ter cerca de 13% de água — grão muito seco não estoura.',
        experimente: 'Conte quantos grãos não estouram em uma panela e pense no que faz o grão falhar.',
    },
    {
        tema: 'Cores',
        fato: 'O céu é azul porque a atmosfera espalha mais a luz azul que a vermelha.',
        detalhe: 'No fim da tarde a luz atravessa mais ar, e por isso o vermelho aparece.',
        experimente: 'Compare a cor do céu ao meio-dia e no pôr do sol, com uma foto de cada.',
    },
];
//# sourceMappingURL=curiosidades.js.map